module.exports = __webpack_public_path__ + "media/images/bu_03-16b8ebcb6682c6dec86f82fa9e280273.jpg";